import React, { useEffect, useState } from "react";
import { keyframes, mergeStyles } from '@fluentui/merge-styles';
import { AvatarOption, initialOptions } from "../../..";

const pulse = keyframes({
    '0%': { opacity: 1 },
    '50%': { opacity: 0.45 },
    '100%': { opacity: 1 },
});

const cardsRow = mergeStyles({
    display: 'flex',
    flexWrap: 'wrap',
    gap: 'var(--druid-space-24)',
    padding: 'var(--druid-space-8) 0',
});

const card = (selected: boolean) => mergeStyles({
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--druid-space-8)',
    padding: 'var(--druid-space-8)',
    margin: 0,
    background: 'transparent',
    border: `1px solid ${selected ? 'var(--druid-color-success-primary)' : 'transparent'}`,
    borderRadius: 'var(--druid-radius-12)',
    color: selected ? 'var(--druid-color-text-primary)' : 'var(--druid-color-text-secondary)',
    fontFamily: 'inherit',
    fontSize: 'var(--druid-font-size-lg)',
    textAlign: 'left',
    cursor: 'pointer',
    transition: 'border-color var(--druid-transition-fast) ease, color var(--druid-transition-fast) ease, transform var(--druid-transition-fast) ease',
    selectors: {
        ':hover': {
            transform: 'translateY(-2px)',
            color: 'var(--druid-color-text-primary)',
            borderColor: selected ? 'var(--druid-color-success-primary)' : 'var(--druid-color-border)',
        },
    },
});

const image = mergeStyles({
    display: 'block',
    width: 140,
    height: 186,
    objectFit: 'cover',
    borderRadius: 'var(--druid-radius-12)',
});

const placeholder = mergeStyles({
    width: 140,
    height: 186,
    margin: 'var(--druid-space-8)',
    borderRadius: 'var(--druid-radius-12)',
    backgroundColor: 'var(--druid-grey-200)',
    animationName: pulse,
    animationDuration: '1.4s',
    animationIterationCount: 'infinite',
});

interface AvatarSelectorProps {
    id: string;
    value: any;
    onChange: (styleElementName: string, value: any) => void;
}

export const AvatarSelector = (props: AvatarSelectorProps) => {
    const { id, value, onChange } = props;
    const [avatars, setAvatars] = useState<AvatarOption[] | null>(null);

    useEffect(() => {
        Promise.resolve()
            .then(() => initialOptions.getAvatarList())
            .then(setAvatars)
            .catch(() => setAvatars([]));
    }, []);

    if (!avatars) {
        return <div className={cardsRow}>{[0, 1].map(i => <div key={i} className={placeholder} />)}</div>;
    }

    return (
        <div className={cardsRow}>
            {avatars.map(avatar => (
                <button
                    key={avatar.id}
                    type="button"
                    className={card(avatar.id === value?.selectedAvatarId)}
                    onClick={() => onChange(id, { selectedAvatarId: avatar.id, selectedAvatarName: avatar.name })}
                >
                    <img className={image} src={avatar.previewUrl} alt="" />
                    <span>{avatar.name}</span>
                </button>
            ))}
        </div>
    );
};

export default AvatarSelector;
